export enum EUiLinkClassNames {
  GuestSeriesPreview = 'guestSeries-preview-anchor',
  ThoughtPreview = 'thought-preview-anchor',
}
